"use client";

import React from "react";
import { Phone, Mail, MapPin, ShieldCheck, ArrowRight, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactInfo = [{
  label: "DIRECT LINE",
  value: "+44 (0) 20 7123 4567",
  icon: Phone,
  href: "tel:+442071234567"
}, {
  label: "GENERAL ENQUIRIES",
  value: "hello@pulseav.co.uk",
  icon: Mail,
  href: "mailto:hello@pulseav.co.uk"
}, {
  label: "HEADQUARTERS",
  value: "Unit 4, Tech Park, London, UK",
  icon: MapPin,
  href: "#"
}];
export default function ContactDetailsCommitment() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}